module.exports = __webpack_public_path__ + "img/ML.843da929.svg";